<template>
  <VModal ref="modal" @modal:hidden="$emit('close')">
    <div class="rounded shadow-xs w-full max-w-md mx-auto" @click.stop>
      <div class="rounded shadow-lg bg-white overflow-hidden space-y-4 lg:space-y-6 pb-4">
        <div class="px-4 pt-4 lg:px-6 lg:pt-6">
          <h3 class="text-base">Select Pipeline</h3>
        </div>
        <div class="px-4 lg:px-6">
          <BaseFormInput placeholder="search pipelines..." v-model.lazy="search" />
        </div>
        <div class="space-y-2">
          <div class="px-4 lg:px-6">
            <h4 class="text-xs tracking-wide text-gray-600 uppercase font-medium">Results</h4>
          </div>
          <div v-if="isRejected" class="px-4 lg:px-6 text-sm text-red-600 text-center">
            Something went wrong.
          </div>
          <ul v-else>
            <li
              v-for="pipeline in pipelines"
              :key="pipeline.id"
              class="px-4 lg:px-6 text-sm h-10 hover:bg-gray-200 space-x-4 truncate flex items-center cursor-pointer group justify-between"
              @click="selectPipeline(pipeline)"
            >
              <span class="inline-block truncate">
                {{ pipeline.name }}
              </span>
              <span class="hidden group-hover:inline-flex text-gray-600"> Select </span>
            </li>
          </ul>
          <div v-if="hasMore" class="p-4 lg:p-6 text-center">
            <BaseButton primary @click="loadMore"> Load more... </BaseButton>
          </div>
        </div>
      </div>
    </div>
  </VModal>
</template>

<script>
import { accountPipelinesClient } from '@/api/clients';

const STATE_IDLE = 'STATE_IDLE';
const STATE_PENDING = 'STATE_PENDING';
const STATE_RESOLVED = 'STATE_RESOLVED';
const STATE_REJECTED = 'STATE_REJECTED';

export default {
  name: 'PipelinePickerDialog',

  props: {
    accountId: {
      type: String,
      required: true,
    },
    onRequestParams: {
      type: Function,
      default: (params) => params,
    },
  },

  data() {
    return {
      search: '',
      state: STATE_IDLE,
      pipelines: [],
      meta: null,
    };
  },

  computed: {
    isResolved() {
      return this.state === STATE_RESOLVED;
    },
    isRejected() {
      return this.state === STATE_REJECTED;
    },
    hasMore() {
      if (!this.meta) {
        return false;
      }

      const { current_page: currentPage, last_page: lastPage } = this.meta;
      return currentPage < lastPage;
    },
  },

  watch: {
    search: 'filterPipelines',
  },

  created() {
    this.fetchPipelines();
  },

  methods: {
    filterPipelines(search) {
      this.fetchPipelines({ filter: { search } });
    },
    loadMore() {
      if (!this.hasMore) {
        return;
      }

      this.fetchPipelines(
        {
          filter: { search: this.search },
          page: this.meta.current_page + 1,
        },
        false
      );
    },
    async fetchPipelines(params = {}, replace = true) {
      if (this.state === STATE_PENDING) {
        return;
      }

      try {
        this.state = STATE_PENDING;

        const {
          data: { data, meta },
        } = await accountPipelinesClient.list(this.accountId, {
          params: this.onRequestParams(params),
        });

        this.pipelines = replace ? data : [...this.pipelines, ...data];
        this.meta = meta;

        this.state = STATE_RESOLVED;

        if (this.meta.current_page === 1) {
          this.loadMore();
        }
      } catch (error) {
        this.state = STATE_REJECTED;
      }
    },
    // eslint-disable-next-line no-unused-vars
    selectPipeline(pipeline) {
      this.$emit('input', pipeline.id);
      this.$refs.modal.close();
    },
  },
};
</script>
